export default __webpack_public_path__ + "static/media/videSupportGIrl.18f92ba9.png";